import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfccg {
    static setTitle(title) {
        $(".zfccg-content-group.zfccg-content-group-sticky .zfccg-text-headline")
            .empty()
            .text(title);
    }
    static init() {
        try {
            zfccg.headerWrapper = $(".zfch2-header2 .zfch2-header2-wrapper");
            zfccg.headerSeperatorHolder = $(".zfch2-header2 .zfch2-header2-sticky-cg-holder");
            if (!zfccg.headerSeperatorHolder.length) {
                return;
            }
            zfccg.stickySeperators = [];
            $(".zfccg-content-group.zfccg-content-group-sticky").each(function () {
                if (this.initialized) {
                    return;
                }
                var el = $(this);
                var clonedItem = el.clone();
                clonedItem.attr("id", "");
                zfccg.headerSeperatorHolder.append(clonedItem);
                zfccg.stickySeperators.push({
                    el: el,
                    clonedItem: clonedItem,
                    sticked: false,
                });
                this.initialized = true;
            });
            if (!zfccg.scrolRegistered) {
                zfccg.scrolRegistered = true;
                if ($(".zfccg-content-group-sticky").length > 0) {
                    zfUtils.onScroll(function () {
                        var lastSeperator = null;
                        var offset = zfc.window.scrollTop() + zfccg.headerWrapper.height();
                        zfccg.stickySeperators.forEach(function (s) {
                            if (offset > Math.floor(s.el.offset().top) + 1) {
                                lastSeperator = s;
                            }
                        });
                        zfccg.headerSeperatorHolder.children().removeClass("active");
                        if (lastSeperator) {
                            lastSeperator.clonedItem.addClass("active");
                        }
                    });
                }
            }
            $(".zfccg-sticky-back")
                .off("click.zfccg")
                .on("click.zfccg", function () {
                if (document.referrer == "")
                    $(".zfch2-header2-logo img").click();
                else if (document.referrer == window.location.href &&
                    window.history.length > 2)
                    window.history.go(-1);
                else
                    window.history.back();
                return false;
            });
        }
        catch (err) {
            console.log("initalization failed: zfccg.init() " + err.message);
        }
    }
}
zfccg.scrolRegistered = false;
zfccg.stickySeperators = [];
try {
    zfUtils.onReady(zfccg.init);
}
catch (err) {
    console.log("initalization failed: zfccg.init() " + err.message);
}
